import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React from "react";
import {LabelContainer} from "./data-label.styles.js";
import {makeStyles} from "../../../../__snowpack__/pkg/@mui/styles.js";
const useStyles = makeStyles({
  flex_col1: {
    alignItems: "flex-start"
  },
  word_break: {
    wordBreak: "break-all"
  }
});
function DataLabel({
  label,
  content
}) {
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(LabelContainer, {
    className: classes.flex_col1
  }, /* @__PURE__ */ React.createElement(MaterialTypography, {
    variant: "caption"
  }, label), /* @__PURE__ */ React.createElement(MaterialTypography, {
    className: classes.word_break,
    variant: "body2"
  }, content));
}
export default /* @__PURE__ */ React.memo(DataLabel);
